if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      this.hideErrors = this.dataset.hideErrors === 'true';
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
      this.handleErrorMessage();

      const section = document.querySelector(`#shopify-section-${this.dataset.sectionId}`) || document;
      const colorSelector = section.querySelector('[data-artka-color-selector]');

      if (colorSelector) {
        const colorField = colorSelector.querySelector('.choose_yours_color_property_field:checked');
        const colorError = colorSelector.querySelector('[data-artka-color-error]');

        if (!colorField) {
          if (colorError) colorError.hidden = false;
          const colorDisclosure = colorSelector.querySelector('[data-artka-color-disclosure]');
          if (colorDisclosure) colorDisclosure.open = true;
          colorSelector.querySelector('.choose_yours_color_property_field')?.focus();
          return;
        }

        if (colorError) colorError.hidden = true;
      }

      const wheelSpec = section.querySelector('[data-artka-wheel-spec]');

      if (wheelSpec) {
        const wheelSpecField = wheelSpec.querySelector('.artka-wheel-spec__field');
        const wheelSpecError = wheelSpec.querySelector('[data-artka-wheel-spec-error]');

        if (!wheelSpecField || !wheelSpecField.value.trim()) {
          if (wheelSpecError) wheelSpecError.hidden = false;
          wheelSpecField?.focus();
          return;
        }

        if (wheelSpecError) wheelSpecError.hidden = true;
      }

      const formData = new FormData(this.form);
      
      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner')?.classList.remove('hidden');
      this.submitButton.querySelector('[data-addtocart-text]').classList.add('hidden');
      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
   

      
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
      
      }
      config.body = formData;
      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {source: 'product-form', productVariantId: formData.get('id'), errors: response.description, message: response.message});
            this.handleErrorMessage(response.description);
           
            this.submitButton.setAttribute('aria-disabled', true);
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }
          if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form', productVariantId: formData.get('id')});
          this.error = false;
          if(document.querySelector('#product-quic-kview')&& document.querySelector('#product-quic-kview').classList.contains("active")){
            document.querySelector('#product-quic-kview').classList.remove("active")
          }
          if(this.cart){
            this.cart.renderContents(response);
            this.cart.classList.add("active");
            let cartItemsElement = this.cart.querySelector(".side-drawer-modal-inner");
            setTimeout(function(){
              focusElement == "" && (focusElement =  this.submitButton)
              trapFocusElements(cartItemsElement)
            },1500)
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          this.submitButton.querySelector('[data-addtocart-text]').classList.remove('hidden');
          if (this.cart && this.cart.classList.contains('is-empty'))
          this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner')?.classList.add('hidden');
       
        });
    }

    handleErrorMessage(errorMessage = false) {
     if (this.hideErrors) return;
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
